import { useQuery } from '@apollo/client';
import { useRouter } from 'next/router';
import * as MENUS from '../constants/menus';
import { BlogInfoFragment } from '../fragments/GeneralSettings';
import { Main, SEO, NavigationMenu } from '../components';
import {
  Header,
  Footer,
  HeroSection,
  ServicesSection,
  FeaturedWorkSection,
  TechnologySection,
  BlogPreviewSection,
  TeamCultureSection,
  FinalCTASection,
} from '../components/sections';
import {
  GET_FRONT_PAGE_WITH_POSTS,
  getLogoNodesFromPageData,
  getRecentPostNodesFromPageData,
  getFeaturedCaseImageUrls,
  mapLogoPostsToLogos,
  mapRecentPostsToPreview,
} from '../lib/queries/frontPage';
import { getCanonicalUrl } from '../lib/siteUrl';

export default function Component() {
  const router = useRouter();
  const { data, loading, error } = useQuery(Component.query, {
    variables: Component.variables(),
  });

  // Resolve data: use API result when available, else fallbacks. This avoids blocking
  // LCP on GraphQL—hero and above-the-fold content paint immediately.
  const { title: siteTitle, description: siteDescription } =
    data?.generalSettings ?? {};
  const logoNodes = loading || error ? [] : getLogoNodesFromPageData(data);
  const homeLogos = mapLogoPostsToLogos(logoNodes);
  const featuredCaseImageUrls = loading || error ? {} : (getFeaturedCaseImageUrls(data) ?? {});
  const recentNodes = loading || error ? [] : getRecentPostNodesFromPageData(data, 'en');
  const blogPosts = mapRecentPostsToPreview(recentNodes, '/blog');
  const canonicalUrl = getCanonicalUrl(router?.asPath || '/');

  return (
    <>
      <SEO title={siteTitle} description={siteDescription} url={canonicalUrl} />
      <Header />
      <Main>
        <HeroSection variant="home" logos={homeLogos} />
        <ServicesSection variant="home" />
        <FeaturedWorkSection featuredCaseImageUrls={featuredCaseImageUrls} />
        <TechnologySection variant="home" />
        <TeamCultureSection />
        <BlogPreviewSection posts={blogPosts} />
        <FinalCTASection variant="simple" />
      </Main>
      <Footer />
    </>
  );
}

Component.query = GET_FRONT_PAGE_WITH_POSTS;

Component.variables = () => ({
  headerLocation: MENUS.PRIMARY_LOCATION,
  footerLocation: MENUS.FOOTER_LOCATION,
});
